import React from "react"
import TextField from "@mui/material/TextField";
import FileUploader from "components/MediaTel/FileUploader";
import FileViewer from "components/MediaTel/FileViewer";
import Button from "@mui/material/Button";
import classnames from "classnames";

import { useSelector, useDispatch } from "react-redux";
import {
  appdataSelector,
  appdata_setActiveRequestType,
  appdata_setActiveRequestState,
  appdata_setSnackbar,
  appdata_setActiveRequestID

} from "reducers/appdata/appdata";
import {
  vendor_save_to_sap,
  vendordataSelector,
  vendordata_updateActiveVendor,
  vendordata_clearAllVendorData,
  vendordata_setSavedToSAP
} from "reducers/vendordata/vendordata";
import Loader from "components/Loading/Loader";
import { useEffect } from "react";
import { renderDropdown } from "components/MediaTel/DropdownAutoComplete";
import { useNavigate } from "react-router";
import Feedback from "../../partials/Feedback";

function Create(props) {
  const dispatch = useDispatch();
  
  const appdata = useSelector(appdataSelector);
  const vendordata = useSelector(vendordataSelector);

  useEffect(() => {
    console.log("NEW CREATE");

    if (!appdata.isResetRequest) {
      dispatch(vendordata_clearAllVendorData());
      dispatch(appdata_setActiveRequestID(null));
    }

    if (appdata.activeRequestType != appdata.requestTypes.NEW_VENDOR) {
      dispatch(appdata_setActiveRequestType(appdata.requestTypes.NEW_VENDOR));
    }

    if (appdata.activeRequestState != appdata.requestStates.CREATE) {
      dispatch(appdata_setActiveRequestState(appdata.requestStates.CREATE));
    }

    if (vendordata.savedToSAP) {
      dispatch(vendordata_setSavedToSAP(false));
    }
  }, []);

 

 

  console.log("create vendor ", props, vendordata.activeVendor);

  let typeOfRequest = "";
  let companySelected = "";
  let accountSelected = "";
  if (
    appdata.listvalues.requestTypeDropdownValues &&
    vendordata.activeVendor.master
  ) {
    appdata.listvalues.requestTypeDropdownValues.map((item, key) => {
      if (item["VALUE"] === vendordata.activeVendor.master.VEND_TYP)
        typeOfRequest = item;
    });

    if (appdata.listvalues.companyDropdownValues) {
      appdata.listvalues.companyDropdownValues.map((item, key) => {
        if (item["BUKRS"] === vendordata.activeVendor.master.BUKRS)
          companySelected = item;
      });
    }

    if (appdata.listvalues.companyAccountCodes) {
      appdata.listvalues.companyAccountCodes.map((item, key) => {
        if (item["KTOKK"] === vendordata.activeVendor.master.KTOKK)
          accountSelected = item;
      });
    }
  }

  const handleSelectChange = (value, type = null) => {
    console.log("handle select change", value, type);
    dispatch(
      vendordata_updateActiveVendor({ part: "master", key: type, value: value })
    );
  };

  const showEmployeeVendorIDInput = () => {
    console.log("showEmployeeVendorIDInput", vendordata.activeVendor.master);
    if (
      vendordata.activeVendor.master &&
      vendordata.activeVendor.master.KTOKK &&
      vendordata.activeVendor.master.KTOKK.indexOf("EM") == 0
    ) {
      console.log("showEmployeeVendorIDInput yes");
      return true;
    }
    console.log("showEmployeeVendorIDInput no");
    return false;
  };

  const allowSave = () => {
    if (Object.keys(vendordata.files).length > 0) {
      return true;
    }
    return false;
  };

  const handleSave = () => {
    dispatch(appdata_setSnackbar({ open: true, message: "Saving..." }));

    dispatch(vendor_save_to_sap());
  };


  if (vendordata.savedToSAP) {
    return (
      <Feedback header="New Vendor"></Feedback>
    );
  }

  let containerClass = "no-breadcrumb chapter mt-4";
  if (!appdata.isResetRequest) {
    containerClass += " container-fluid"
  }

  let accountCodes = appdata.listvalues.companyAccountCodes.filter(account => !account.KTOKK.startsWith("EM"));

  return (
    <article className="article">
      <div className={containerClass}>
        {!appdata.isResetRequest && (
          <h2 className="article-title">
            New Vendor
          </h2>
        )}

        {appdata.isResetRequest && (
          <React.Fragment>
            <h2 className="article-title">
              Update Request
            </h2>
            <div className="mt-2">
              <b>Message: {vendordata.activeVendor.master.ZCOMMENT}</b>
            </div>
          </React.Fragment>
        )}
        <div className="mt-4">
          {/* type of request */}
          {/* type of request */}
          {/* type of request */}
          {/* type of request */}
          {renderDropdown(
            "Type of request",
            appdata.listvalues["requestTypeDropdownValues"],
            typeOfRequest,
            "VEND_TYP",
            "VALUE",
            ["VALUE", "DESCRIPTION"],
            handleSelectChange
          )}

          {/* company */}
          {/* company */}
          {/* company */}
          {/* company */}
          {renderDropdown(
            "Company",
            appdata.listvalues.companyDropdownValues,
            companySelected,
            "BUKRS",
            "BUKRS",
            ["BUKRS", "BUTXT"],
            handleSelectChange
          )}

          {/* account */}
          {/* account */}
          {/* account */}
          {/* account */}
          {/* account */}
          {renderDropdown(
            "Account",
            accountCodes,
            accountSelected,
            "KTOKK",
            "KTOKK",
            ["KTOKK", "TXT30"],
            handleSelectChange
          )}

          {/* employee vendor input based on account */}
          {/* employee vendor input based on account */}
          {/* employee vendor input based on account */}
          {/* employee vendor input based on account */}
          {/* employee vendor input based on account */}
          {showEmployeeVendorIDInput() && (
            <TextField
              className="mt-5"
              style={{
                width: 400,
                backgroundColor: "white"
              }}
              id="outlined-basic"
              label="Employee Vendor ID"
              variant="outlined"
              value={
                vendordata.activeVendor.master &&
                  vendordata.activeVendor.master.EMP_LIFNR
                  ? vendordata.activeVendor.master.EMP_LIFNR
                  : ""
              }
              onChange={event => {
                dispatch(
                  vendordata_updateActiveVendor({
                    part: "master",
                    key: "EMP_LIFNR",
                    value: event.target.value
                  })
                );
              }}
            />
          )}

          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          {/* fileuploader */}
          <FileUploader ></FileUploader>

          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          {/* fileViewer */}
          <FileViewer enableRemove={appdata.isResetRequest}></FileViewer>

          {/* save button */}
          {/* save button */}
          {/* save button */}
          {/* save button */}
          {allowSave() && !vendordata.saving && (
            <Button
              className={classnames("besiButton", "d-print-none", "mt-5")}
              variant="contained"
              key="savebutton"
              onClick={() => handleSave()}
            >
              Save
            </Button>
          )}

          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {/* loader when saving */}
          {vendordata.saving && (
            <div className="mt-4">
              <Loader size="30"></Loader>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}

export default Create;
